import React, { useState } from 'react';
import { useSelector } from "react-redux"
import { Button, Dialog as MUIDialog, CircularProgress } from "@material-ui/core";
import { ReactComponent as RefundSVG } from "../../../assets/images/icon-refund-square.svg";
import { ReactComponent as CloseSVG } from "../../../assets/images/icon-close-square.svg";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
// import { useAuth0 } from '../../../yoello-lib/modules/auth/Auth0';
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import APIExtensionsv2 from "../../../yoello-lib/modules/API2/APIDefs";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from 'react-i18next';
import { useStyles } from "./styles"
import useFormatCurrency from '../../../yoello-lib/modules/localisation/useCurrency';
import { RefundActionType, RefundReasons } from './types';
import { IPlacedOrder, DialogOrderTypes, OrderOptions } from '../constants';
import { dialogKeys } from '../../../const/URL.const';
import { useDialogRouteStages } from '../../dialogRoutes/useDialogRouteStages';
import { IReduxAppState } from "../../../reducers";

interface IConfirmationModal {
  totalRefundedValue: number;
  setIsOpen: (isOpen: boolean) => void;
  refundActionType: RefundActionType,
  isOpen: boolean,
  placedOrder: IPlacedOrder;
  history: any;
  path: string;
  venueId: string;
}
export function ConfirmationModal({ totalRefundedValue, setIsOpen, refundActionType, isOpen, placedOrder, history, path, venueId }: IConfirmationModal) {
  const classes = useStyles();
  // const { retrieveToken } = useAuth0()!;
  const [isLoading, setIsLoading] = useState(false);
  const { getProps, setProps, closeAllModals, goToNextStep } = useDialogRouteStages(history)
  const { callAPI: callPlacedOrders } = useAPIV2(APIExtensions.placedOrders, { onMountDisabled: true });
  const { callAPI: callDeclineOrder } = useAPIV2(APIExtensionsv2.placedOrders, { onMountDisabled: true });
  const { callAPI: callDeclinePay360 } = useAPIV2(APIExtensionsv2.payrefunds, { onMountDisabled: true });
  const venue = useSelector((state: IReduxAppState) => state.venue[venueId].venueData);
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
  const isPAY360Venue = (venue?.payment_processor === "PAY360");
  const isRefund = refundActionType === RefundActionType.REFUND;
  const isOrderOnly = placedOrder.placed_order_order_option === OrderOptions.ORDER_ONLY;

  const { formatCurrency } = useFormatCurrency();
  const { t } = useTranslation();
  function renderTitle() {
    const { reason } = getProps(dialogKeys.ORDER);
    switch (refundActionType) {
      case RefundActionType.REFUND:
        return <div>
          <RefundSVG />
          <p style={{ color: "#FA7800" }}>
            {RefundReasons.REFUNDENTIRE === reason ? t(`PartialReafund.OrderHistory.ConfirmationModal.EntireRefundTitle`) : t(`PartialReafund.OrderHistory.ConfirmationModal.Title`)}
          </p>
        </div>

      default:
        return <div>
          <CloseSVG />
          <p style={{ color: "#F52D5C" }} className={isOrderOnly ? classes.ConfirmationModalTitle : ''}>
            {t(`PartialReafund.NewOpenOrders.ConfirmationModal.${isOrderOnly ? 'OrderOnlyTitle':'Title'}`)}
          </p>
        </div>
    }
  }

  async function onConfirm() {
    const { url, reason, dialogType, refundType, inOrderIds, orderAPICall, path: OriginPath, selectedMenuItemIds } = getProps(dialogKeys.ORDER);
    setIsLoading(true);
    if (isRefund) {
      let response;
      if (isEposNow) {
        response = await callPlacedOrders(HTTPMethods.POST,
           { query: `${placedOrder.placed_order_id}/void`,
          body:{
            reason:"EposNow Void",
            venue_id:venueId
          } }
           );
        setIsOpen(false);
        setProps(dialogKeys.ORDER, "refundType", undefined);
        setProps(dialogKeys.ORDER, "reason", undefined);
        orderAPICall(HTTPMethods.GET);
        goToNextStep(
          dialogKeys.ORDER,
          {
            ComponentProps: { orderID: placedOrder.placed_order_id, orderAPICall: orderAPICall, url: url, dialogType: dialogType }
          }, `${path}/${placedOrder.placed_order_id}`, null)
      }
      else {
        if (isPAY360Venue) {
          response = await callDeclinePay360(HTTPMethods.POST, {
            body: {
              transaction_id: placedOrder.placed_order_integration_payment_object_id,
              placed_order_hash_id: placedOrder.placed_order_hash_id,
              //as backend decided exactly based on out_of_stock word
              reason: reason === RefundReasons.STOCK ? "out_of_stock" : "other",
            },
            yoelloAPIParams: { venue_id: venueId }
          });
        } else {
          response = await callPlacedOrders(HTTPMethods.POST, {
            query: `${placedOrder.placed_order_id}/refunds`,
            body: {
              venue_id: venueId,
              refund_type: refundType,
              reason: reason === RefundReasons.STOCK ? "out_of_stock" : reason,
              in_order_ids: inOrderIds,
              order_details_url: url,
              include_extras: true
            },
            errorCall: totalRefundedValue > (placedOrder.placed_order_order_total - placedOrder.total_refund_amount) ? t('order.refundDialog.refundOverflow') : t('order.refundDialog.apiError')
          })
        }
        if (response.isSuccessful) {
          setIsOpen(false);
          setProps(dialogKeys.ORDER, "refundType", undefined);
          setProps(dialogKeys.ORDER, "reason", undefined);
          orderAPICall(HTTPMethods.GET);
          goToNextStep(
            dialogKeys.ORDER,
            {
              ComponentProps: { orderID: placedOrder.placed_order_id, orderAPICall: orderAPICall, url: url, dialogType: dialogType }
            }, `${path}/${placedOrder.placed_order_id}`, null)
        }
      }
      setIsLoading(false);
    }
    //declining
    else {
      if (isPAY360Venue) {
        await callDeclinePay360(HTTPMethods.POST, {
          body: {
            transaction_id: placedOrder.placed_order_integration_payment_object_id,
            placed_order_hash_id: placedOrder.placed_order_hash_id,
            //as backend decided exactly based on out_of_stock word
            reason: reason === RefundReasons.STOCK ? "out_of_stock" : "other",
            item_ids: selectedMenuItemIds
          },
          yoelloAPIParams: { venue_id: venueId }
        });
      } else {
        const reasonIsOutOfStock = reason === RefundReasons.STOCK;
        let declineBody:any = {
          reason:`${
            //as backend decided exactly based on out_of_stock word
            reasonIsOutOfStock ? "out_of_stock" : reason
            }`,
          venue_id: venueId,
      }
      if(reasonIsOutOfStock && selectedMenuItemIds){
        declineBody.item_ids = selectedMenuItemIds;
      }
        await callDeclineOrder(HTTPMethods.POST, {
          query: `${placedOrder.placed_order_id}/decline`, 
            body:declineBody
        });
      }
      setIsLoading(false);
      setIsOpen(false);
      setProps(dialogKeys.ORDER, "refundType", undefined);
      setProps(dialogKeys.ORDER, "reason", undefined);
      if (dialogType === DialogOrderTypes.ORDER_HISTORY) {
        orderAPICall(HTTPMethods.GET);
        goToNextStep(
          dialogKeys.ORDER,
          {
            ComponentProps: { orderID: placedOrder.placed_order_id, orderAPICall: orderAPICall, url: url, dialogType: dialogType }
          }, `${path}/${placedOrder.placed_order_id}`, null)
      } else {
        const { setMessageOptions } = getProps(dialogKeys.ORDER);
        setMessageOptions(true);
        closeAllModals(OriginPath);
      }
    }
  }
  return (

    <MUIDialog
      open={isOpen}
      maxWidth={"md"}
      className={classes.ModalContainer}
      transitionDuration={300}
      data-component-name="dialog"
    >
      <>
        <header className={classes.ConfirmationModalHeader}>
          <div>
            {renderTitle()}
            {!isOrderOnly && <div data-component-name="TOTAL_REFUND_VALUE">
              <p>{t('PartialReafund.TotalRefundValue')}</p>
              <p>{formatCurrency(totalRefundedValue)}</p>
            </div>}
          </div>
          <div>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setIsOpen(false)}
              aria-label="close"
              data-component-name="DialogCloseButton"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </header>
        {isLoading ? <div style={{ margin: "6rem 10rem", display: "flex", alignItems: "center", justifyContent: "center" }}><CircularProgress /></div> : <div className={classes.ConfirmationModalBody}>
          <div className={classes.ConfirmationModalContent}>
            <p>{t('PartialReafund.ConfirmationContent')}</p>
            <p>{t('PartialReafund.ConfirmationBoldContent')}</p>
          </div>
          <footer className={classes.ConfirmationModalFooter}>
            <Button
              style={{ padding: "0.9375rem 1.5625rem", color: "#212121", backgroundColor: "#FFFFFF" }}
              variant={'contained'}
              disabled={false}
              onClick={() => setIsOpen(false)}
              data-component-name="CONFIRMATION_CANCEL"
            >
              {t('PartialReafund.Buttons.Cancel')}
            </Button>
            <Button
              style={refundActionType === RefundActionType.REFUND ? { padding: "0.9375rem 1.5625rem", backgroundColor: "#FEEEE0", marginLeft: "1.25rem", color: "#FA7800" } :
                { padding: "0.9375rem 1.5625rem", backgroundColor: "#FEEAEE", marginLeft: "1.25rem", color: "#F52D5C" }}
              variant={'contained'}
              onClick={onConfirm}
              data-component-name="CONFIRMATION_CONFIRM"
            >
              {t('PartialReafund.Buttons.Continue')}
            </Button>
          </footer>
        </div>}
      </>
    </MUIDialog>
  )
}

